export default __webpack_public_path__ + "static/media/nifty50-survivorship-outperformance-graph.64b5cd12.png";